import React, { memo } from 'react';
import { Box } from '@ublend-npm/aulaui-core';
import SpaceCardSkeleton from './SpaceCardSkeleton';
import {
  SPACE_CARD_GAP,
  SPACE_CARD_HEIGHT,
  SPACE_CARD_SKELETON_SURFACE,
} from './spaceWidgetConstants';

export type SpaceWidgetSkeletonProps = {
  cardCount?: number;
};

const SpaceWidgetSkeleton = ({ cardCount = 4 }: SpaceWidgetSkeletonProps) => (
  <Box
    component="section"
    role="status"
    aria-live="polite"
    aria-busy="true"
    aria-label="Loading your spaces"
    sx={{
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'stretch',
      gap: SPACE_CARD_GAP,
      overflow: 'hidden',
      minWidth: 0,
      width: '100%',
      minHeight: { lg: SPACE_CARD_HEIGHT },
    }}
  >
    {Array.from({ length: cardCount }, (_, index) => (
      <SpaceCardSkeleton
        key={`space-card-skeleton-${index}`}
        skeletonSurface={SPACE_CARD_SKELETON_SURFACE}
      />
    ))}
  </Box>
);

export default memo(SpaceWidgetSkeleton);
